// extracted by mini-css-extract-plugin
export default {"logo-container":"Header_logo-container__QwC34"};